import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=696525f2&scoped=true&"
import script from "./ActivityItem.vue?vue&type=script&lang=js&"
export * from "./ActivityItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=696525f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696525f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696525f2')) {
      api.createRecord('696525f2', component.options)
    } else {
      api.reload('696525f2', component.options)
    }
    module.hot.accept("./ActivityItem.vue?vue&type=template&id=696525f2&scoped=true&", function () {
      api.rerender('696525f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityItem.vue"
export default component.exports